import { Grid, Input, Link, Typography } from "@material-ui/core";
import { EContractTab } from "api/enums";
import MonetaryCard from "components/UI/Fields/MonetaryCard";
import { MessageSnackButton } from "components/UI/Messages";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { uuid } from "utils";
import { getContractRouteOfCurrentURL } from "utils/RoutesUtils";
import ContractMeasurementTable from "../components/Measurement/ContractMeasurementTable";
import { BackButton } from "../components/UI/Buttons";
import { PageHeader, PageLoading, PageTitle } from "../components/UI/Page";
import Page404 from "../components/shared/Errors/404";
import { lang } from "../i18nLang";
import {
  ContractStore,
  MeasurementRowsStore,
  MeasurementStore,
  MessageStore,
} from "../store";

/** Função para evitar que o usuário saia da página antes de salvar. */
let blockUnload = false;
window.addEventListener("beforeunload", (ev) => {
  if (blockUnload) {
    ev.preventDefault();
    return (ev.returnValue = "Are you sure you want to close?");
  }
  return ev;
});

/** Função para evitar que o usuário saia da página pelo botão voltar do navegador. */
window.addEventListener("hashchange", (ev) => {
  ev.preventDefault();
  if (!window.location.hash) window.location.hash = "#" + uuid();
});

const Measurement = observer(({ match }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [showInput, setShowInput] = useState(false);
  const { allRowsLoaded, loadingDelete } = MeasurementStore;
  const name = MeasurementStore.currentMeasurementName;
  const total = MeasurementStore.currentMeasurementTotal;

  const updateRowMessage = MeasurementRowsStore.getUpdateRowMessage();
  const hasUpdateError = MeasurementRowsStore.updateHasFailed();
  const measuredTotal = MeasurementRowsStore.measuredTotalizer;

  useEffect(() => {
    const { id } = match.params;
    setLoading(true);

    // São configurações para impedir que o usuário sai da página sem querer
    blockUnload = true;
    window.location.hash = "#block";

    try {
      ContractStore.setCurrentTabOpened(EContractTab.MEASUREMENT);
      MeasurementStore.subscribeMeasurement(id);
      MeasurementRowsStore.initUpdateService(id);
    } catch (err) {
      console.error(err);
    }

    return () => {
      blockUnload = false;
      MeasurementStore.unsubscribeMeasurement();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoading(!allRowsLoaded);
  }, [allRowsLoaded]);

  const handleClickBack = () => {
    if (MeasurementRowsStore.isUpdateInProgress()) {
      MessageStore.warning(lang("measurements.waitForUpdate"));
      return;
    }

    history.replace(getContractRouteOfCurrentURL());
  };

  const handleClickTitle = () => setShowInput(true);

  const handleKeyDownName = (ev) => {
    if (ev.key === "Enter") handleChangeName(ev);
  };

  const handleChangeName = async (ev) => {
    const newName = ev.target.value;
    await MeasurementStore.updateMeasurementName(newName);
    setShowInput(false);
  };

  const handleClickTryAgain = () => {
    MeasurementRowsStore.retryLastUpdate();
  };

  if (!loading && !MeasurementStore.measurementFounded && !loadingDelete)
    return <Page404 title={lang("measurements.error.notFound")} />;

  return (
    <>
      <PageHeader padding={[0, 1]}>
        <Grid container item xs justifyContent="flex-start">
          <BackButton onClick={handleClickBack} />
          {!showInput && (
            <PageTitle onClick={handleClickTitle}>{name}</PageTitle>
          )}
          {showInput && (
            <Input
              name={"measurement-name"}
              autoFocus={true}
              defaultValue={name}
              onBlur={handleChangeName}
              onKeyDown={handleKeyDownName}
              margin={"none"}
            />
          )}
        </Grid>
        <Grid
          container
          item
          xs={12}
          sm={10}
          md={8}
          justifyContent="flex-end"
          alignItems="center"
        >
          {hasUpdateError ? (
            <Typography style={{ fontStyle: "italic" }}>
              {updateRowMessage}
              <Link
                color="error"
                onClick={handleClickTryAgain}
                style={{ paddingLeft: 5, cursor: "pointer" }}
              >{`${lang("tryAgain")}...`}</Link>
            </Typography>
          ) : (
            <Typography style={{ fontStyle: "italic" }}>
              {updateRowMessage}
            </Typography>
          )}
          <MonetaryCard
            label={measuredTotal?.label || ""}
            value={measuredTotal?.value || 0}
            margin={[0, 0.25, 0, 1]}
          />
          <MonetaryCard
            label={lang("measurements.table.current")}
            value={total}
            margin={[0, 1, 0, 0.25]}
          />
        </Grid>
      </PageHeader>
      <Grid container item xs>
        {loading && <PageLoading title={lang("measurements.loadingTable")} />}
        {!loading && <ContractMeasurementTable />}
      </Grid>
      <MessageSnackButton
        open={hasUpdateError}
        message={lang("measurements.updateFailed")}
        buttonLabel={lang("tryAgain")}
        onClickButton={handleClickTryAgain}
        onClose={() => {}}
        type={"error"}
      />
    </>
  );
});

export default Measurement;
